import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import QuizImg from "../../../componenet/quizimg";
import { useNavigate } from "react-router-dom";
import { userquery } from "../../../redux/authslice";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const Quizquestion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { viewData } = useSelector((state) => state.counter);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [showExplanation, setShowExplanation] = useState(false);
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState("");
  const [queryCheck, setQueryCheckset] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setQuery((prevData) => ({
      ...prevData,
      question: id,
    }));
  };

  const onSubmit = () => {
    dispatch(userquery(dispatch, setShow, query));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQueryCheckset(!(query?.query?.length > 3));
    setQuery((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (viewData.length === 0) {
      navigate("/quizgenerator");
    }
  }, [navigate, viewData]);

  useEffect(() => {
    const questionData = viewData?.data?.[currentQuestionIndex];

    if (questionData) {
      if (
        (questionData.question_type === "mcq" ||
          questionData.question_type === "true_false") &&
        !selectedAnswer
      ) {
        setSelectedAnswer(questionData?.answer || questionData?.correct_answer);
      }
    }
  }, [currentQuestionIndex, viewData?.data, selectedAnswer]);

  const handleExplanationButtonClick = () =>
    setShowExplanation(!showExplanation);

  const handleNext = () => {
    if (currentQuestionIndex < viewData?.data.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      const nextQuestion = viewData?.data[currentQuestionIndex + 1];
      setSelectedAnswer(
        nextQuestion?.question_type === "mcq"
          ? nextQuestion?.answer || nextQuestion?.correct_answer
          : ""
      );
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      const prevQuestion = viewData?.data[currentQuestionIndex - 1];
      setSelectedAnswer(
        prevQuestion?.question_type === "mcq"
          ? prevQuestion?.answer || prevQuestion?.correct_answer
          : ""
      );
    }
  };

  const onAnswerClick = (answer) => setSelectedAnswer(answer);

  const getBackgroundColor = (isSelected, isCorrect, isBoth) => {
    if (isBoth) return "#d4edda";
    if (isSelected && !isCorrect) return "#f8d7da";
    if (isCorrect && !isSelected) return "#d4edda";
    return "#f0f0f0";
  };

  const questionData = viewData?.data?.[currentQuestionIndex];

  const renderQuestion = () => {
    switch (questionData?.question_type) {
      case "mcq":
        return (
          <ul className="checkbox-list">
            {questionData?.options?.map((ele, index) => {
              const isSelected = selectedAnswer === ele;
              const isCorrect = questionData?.correct_answer === ele;
              const isBoth = isSelected && isCorrect;
              const itemClass = isSelected
                ? "third-checkbox"
                : isCorrect
                ? "second-checkbox"
                : "first-checkbox";

              return (
                <li
                  key={index}
                  className={itemClass}
                  style={{
                    backgroundColor: getBackgroundColor(
                      isSelected,
                      isCorrect,
                      isBoth
                    ),
                  }}
                >
                  <input
                    type="checkbox"
                    id={`item-${index}`}
                    checked={isSelected}
                    disabled
                    onChange={() => onAnswerClick(ele)}
                  />
                  <label htmlFor={`item-${index}`} className="text">
                    {ele}
                    {isBoth && <span className="last-ans"> You Answered</span>}
                    {isSelected && !isBoth && (
                      <span className="last-ans"> You answered</span>
                    )}
                    {!isSelected && isCorrect && (
                      <span className="last-ans"> Correct Answer</span>
                    )}
                  </label>
                </li>
              );
            })}
          </ul>
        );

      case "fill_ups":
        return (
          <>
            <div
              className="your-answer-feedback-only"
              style={{
                backgroundColor:
                  questionData?.is_right == true ? "#d4edda" : "#f8d7da",
              }}
            >
              <input
                style={{
                  width: "77%",
                  height: "calc(100% - 20px)",
                  paddingLeft: "20px",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                }}
                type="text"
                value={questionData?.answer}
                readOnly
              />
              <label
                style={{
                  fontSize: "13px",
                  color: questionData?.is_right == true ? "#3d7e4c" : "#ff0017",
                }}
              >
                You answered
              </label>
            </div>

            <div
              className="your-answer-feedback-only"
              style={{
                backgroundColor: "#d4edda",
              }}
            >
              <input
                style={{
                  width: "77%",
                  height: "calc(100% - 20px)",
                  paddingLeft: "20px",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                }}
                type="text"
                value={questionData?.correct_answer}
                readOnly
              />
              <label style={{ fontSize: "13px", color: "#3d7e4c" }}>
                Correct answer
              </label>
            </div>
          </>
        );

      case "short_answer":
        return (
          <>
            <div
              className="your-answer-feedback-only"
              style={{
                backgroundColor:
                  questionData?.is_right == true ? "#d4edda" : "#f8d7da",
                padding: "5px",
                marginBottom: "10px",
              }}
            >
              <textarea
                className="form-control"
                rows="3"
                value={selectedAnswer || questionData?.answer}
                readOnly
                style={{
                  width: "80%",
                  height: "80px",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  resize: "none",
                  overflow: "hidden",
                }}
              />
              <label
                className="Corrected1"
                style={{
                  color: questionData?.is_right == true ? "#3d7e4c" : "#ff0017",
                }}
              >
                You answered
              </label>
            </div>

            <div
              className="correct-answer-feedback-only"
              style={{
                backgroundColor: "#d4edda",
                padding: "5px",
              }}
            >
              <textarea
                className="form-control"
                rows="3"
                value={questionData?.correct_answer}
                readOnly
                disabled
                style={{
                  width: "100%",
                  height: "80px",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  display: "flex",
                  resize: "none",
                  overflow: "hidden",
                }}
              />
              <label className="Corrected">Correct answer</label>
            </div>
          </>
        );

      case "true_false":
        const isTrueSelected =
          selectedAnswer === "True" || selectedAnswer === "true";
        const isFalseSelected =
          selectedAnswer === "False" || selectedAnswer === "false";
        const correctAnswer = questionData?.correct_answer
          ? questionData.correct_answer.charAt(0).toUpperCase() +
            questionData.correct_answer.slice(1)
          : "";

        return (
          <ul className="checkbox-list">
            <li
              className="second-checkbox"
              style={{
                backgroundColor: getBackgroundColor(
                  isTrueSelected,
                  correctAnswer === "True",
                  isTrueSelected && correctAnswer === "True"
                ),
              }}
            >
              <input
                type="checkbox"
                id="true-checkbox"
                disabled
                checked={isTrueSelected}
                onChange={() => onAnswerClick("True")}
              />
              <label htmlFor="true-checkbox">
                True
                <span className="last-ans">
                  {isTrueSelected
                    ? "You answered"
                    : correctAnswer === "True" && !isTrueSelected
                    ? "Correct Answer"
                    : ""}
                </span>
              </label>
            </li>
            <li
              className="third-checkbox"
              style={{
                backgroundColor: getBackgroundColor(
                  isFalseSelected,
                  correctAnswer === "False",
                  isFalseSelected && correctAnswer === "False"
                ),
              }}
            >
              <input
                type="checkbox"
                disabled
                id="false-checkbox"
                checked={isFalseSelected}
              />
              <label htmlFor="false-checkbox">
                False
                <span className="last-ans">
                  {isFalseSelected
                    ? "You answered"
                    : correctAnswer === "False" && !isFalseSelected
                    ? "Correct Answer"
                    : ""}
                </span>
              </label>
            </li>
          </ul>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <section className="foundation-all">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="algebra-foundation">
                <p className="foundation-heading1">
                  {viewData?.quiz_detail
                    ? `${
                        viewData?.quiz_detail.subject
                          ? viewData?.quiz_detail.subject
                          : ""
                      }-${
                        viewData?.quiz_detail.levelOfStudy
                          ? viewData?.quiz_detail.levelOfStudy
                          : ""
                      }-${
                        viewData?.quiz_detail.board
                          ? viewData?.quiz_detail.board
                          : ""
                      }-${
                        viewData?.quiz_detail.topic
                          ? viewData?.quiz_detail.topic
                          : ""
                      }-${
                        viewData?.quiz_detail.level
                          ? viewData?.quiz_detail.level
                          : ""
                      }`
                    : "Maths-GCSE-AQA-Algebra-Foundation"}
                </p>
                {/* <p className="foundation-heading2">Updated on 12 May, 2024</p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="all-dasboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="question-box">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="question-left">
                      <p className="question3 d-flex justify-content-between">
                        Question {currentQuestionIndex + 1}
                        <i
                          class="fa-solid fa-flag"
                          onClick={() => handleShow(questionData?.Question_id)}
                        ></i>
                      </p>
                      <p className="question-x">{questionData?.question}</p>
                      <br></br>
                      {/* {questionData?.paragraph ? (
                        <>
                          <p className="text-success">Hint :-</p>
                          <p className="question-x text-primary">
                            {questionData?.paragraph}
                          </p>
                        </>
                      ) : null} */}
                    </div>
                    <p className="select-text">
                      Select the correct answer from the options below
                    </p>
                    {renderQuestion()}
                    <div className="foundation-all-button">
                      <button
                        className="btn previous-btn-primary"
                        onClick={handlePrevious}
                        disabled={currentQuestionIndex === 0}
                      >
                        Previous
                      </button>
                      <button
                        className="btn next-btn-primary"
                        onClick={handleNext}
                        disabled={
                          currentQuestionIndex === viewData?.data?.length - 1
                        }
                      >
                        Next
                      </button>
                    </div>
                    <div>
                      <button
                        className="btn submit-quizz-btn-primary mt-3"
                        onClick={handleExplanationButtonClick}
                      >
                        Explanation
                      </button>
                    </div>
                    {showExplanation && (
                      <div className="question-left mt-5">
                        <p>
                          <strong>Explanation:</strong>{" "}
                          {viewData?.data[currentQuestionIndex].explanation}
                        </p>
                      </div>
                    )}
                  </div>
                  <QuizImg
                    QuizzData={viewData?.data}
                    currentQuestionIndex={currentQuestionIndex}
                    userAnswers={viewData?.data}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">
            Feeback (Related to Question/Answer)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-floating">
            <textarea
              className="form-control"
              name="query"
              onChange={handleChange}
              placeholder="Leave a feedback here"
              id="floatingTextarea"
              required
              style={{ height: "100px", paddingTop: "40px" }}
            ></textarea>
            <label for="floatingTextarea" className="mb-3">
              Please leave a query here
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" disabled={queryCheck} onClick={onSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Quizquestion;
